/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M10 6.2955C10.5993 6.1122 11.266 6 12 6C15.3137 6 18 8.68629 18 12C18 15.3137 15.3137 18 12 18C8.68629 18 6 15.3137 6 12C6 10.7666 6.37218 9.62007 7.01037 8.66667M10 6.2955L12 4M10 6.2955L12.3333 8"
				stroke="currentColor"
				strokeWidth="1.67145"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<rect
				x="2"
				y="2"
				width="20"
				height="20"
				rx="5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<rect
				opacity="0.12"
				x="2"
				y="2"
				width="20"
				height="20"
				rx="5"
				fill="currentColor"
			/>
			<path
				d="M10 6.2955C10.5993 6.1122 11.266 6 12 6C15.3137 6 18 8.68629 18 12C18 15.3137 15.3137 18 12 18C8.68629 18 6 15.3137 6 12C6 10.7666 6.37218 9.62007 7.01037 8.66667M10 6.2955L12 4M10 6.2955L12.3333 8M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M3.98005 1.79497C5.04961 1.25 6.44974 1.25 9.25 1.25H14.75C17.5503 1.25 18.9504 1.25 20.02 1.79497C20.9608 2.27433 21.7257 3.03924 22.205 3.98005C22.75 5.04961 22.75 6.44974 22.75 9.25V14.75C22.75 17.5503 22.75 18.9504 22.205 20.02C21.7257 20.9608 20.9608 21.7257 20.02 22.205C18.9504 22.75 17.5503 22.75 14.75 22.75H9.25C6.44974 22.75 5.04961 22.75 3.98005 22.205C3.03924 21.7257 2.27433 20.9608 1.79497 20.02C1.25 18.9504 1.25 17.5503 1.25 14.75V9.25C1.25 6.44974 1.25 5.04961 1.79497 3.98005C2.27433 3.03924 3.03924 2.27433 3.98005 1.79497ZM12.6301 4.549C12.9333 4.201 12.897 3.67309 12.549 3.36989C12.201 3.06669 11.6731 3.103 11.3699 3.451L9.36989 5.7465C9.21611 5.92301 9.1434 6.15592 9.16947 6.38856C9.19554 6.62121 9.31799 6.83225 9.50703 6.97034L11.8404 8.67484C12.2131 8.94711 12.7359 8.86568 13.0082 8.49297C13.2804 8.12027 13.199 7.59742 12.8263 7.32516L12.1596 6.83815C14.9379 6.92249 17.1643 9.20125 17.1643 12C17.1643 14.8522 14.8522 17.1643 12 17.1643C9.14785 17.1643 6.83572 14.8522 6.83572 12C6.83572 10.9372 7.15588 9.95168 7.70486 9.13155C7.96161 8.74799 7.8588 8.22892 7.47525 7.97217C7.09169 7.71543 6.57262 7.81823 6.31587 8.20179C5.58848 9.28845 5.16428 10.596 5.16428 12C5.16428 15.7753 8.22473 18.8357 12 18.8357C15.7753 18.8357 18.8357 15.7753 18.8357 12C18.8357 8.25595 15.8257 5.21493 12.0935 5.1649L12.6301 4.549Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M9.5 2L9 2V2C7.13872 2 6.20808 2 5.45492 2.24472C3.93273 2.73931 2.73931 3.93273 2.24472 5.45492C2 6.20808 2 7.13872 2 9L2 14C2 16.8003 2 18.2004 2.54497 19.27C3.02434 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V9C22 7.13872 22 6.20808 21.7553 5.45492C21.2607 3.93273 20.0673 2.73931 18.5451 2.24472C17.7919 2 16.8613 2 15 2V2L14.5 2M10 6.2955C10.5993 6.1122 11.266 6 12 6C15.3137 6 18 8.68629 18 12C18 15.3137 15.3137 18 12 18C8.68629 18 6 15.3137 6 12C6 10.7666 6.37218 9.62007 7.01037 8.66667M10 6.2955L12 4M10 6.2955L12.3333 8"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M10 6.2955C10.5993 6.1122 11.266 6 12 6C15.3137 6 18 8.68629 18 12C18 15.3137 15.3137 18 12 18C8.68629 18 6 15.3137 6 12C6 10.7666 6.37218 9.62007 7.01037 8.66667M10 6.2955L12 4M10 6.2955L12.3333 8M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M9.25 1.25C6.44974 1.25 5.04961 1.25 3.98005 1.79497C3.03924 2.27433 2.27433 3.03924 1.79497 3.98005C1.25 5.04961 1.25 6.44974 1.25 9.25V14.75C1.25 17.5503 1.25 18.9504 1.79497 20.02C2.27433 20.9608 3.03924 21.7257 3.98005 22.205C5.04961 22.75 6.44974 22.75 9.25 22.75H14.75C17.5503 22.75 18.9504 22.75 20.02 22.205C20.9608 21.7257 21.7257 20.9608 22.205 20.02C22.75 18.9504 22.75 17.5503 22.75 14.75V9.25C22.75 6.44974 22.75 5.04961 22.205 3.98005C21.7257 3.03924 20.9608 2.27433 20.02 1.79497C18.9504 1.25 17.5503 1.25 14.75 1.25H9.25Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12.5488 3.36993C12.8968 3.67314 12.9331 4.20104 12.6299 4.54904L12.0933 5.16495C15.8255 5.21497 18.8355 8.25599 18.8355 12C18.8355 15.7753 15.7751 18.8358 11.9998 18.8358C8.22452 18.8358 5.16406 15.7753 5.16406 12C5.16406 10.596 5.58827 9.28849 6.31566 8.20183C6.5724 7.81827 7.09147 7.71547 7.47503 7.97222C7.85859 8.22896 7.96139 8.74803 7.70465 9.13159C7.15567 9.95173 6.83551 10.9372 6.83551 12C6.83551 14.8522 9.14764 17.1643 11.9998 17.1643C14.8519 17.1643 17.1641 14.8522 17.1641 12C17.1641 9.20129 14.9377 6.92254 12.1594 6.83819L12.8261 7.3252C13.1988 7.59746 13.2802 8.12031 13.008 8.49302C12.7357 8.86572 12.2129 8.94715 11.8401 8.67489L9.50681 6.97039C9.31778 6.8323 9.19533 6.62125 9.16926 6.38861C9.14319 6.15596 9.21589 5.92305 9.36968 5.74655L11.3697 3.45105C11.6729 3.10305 12.2008 3.06673 12.5488 3.36993Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
